import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { LauncherStickyButtonWrapper } from 'modules/connect-card-widget/containers/embed-widget/styles';
import StickyButton from 'modules/connect-card-widget/components/launchers/StickyButton';
import classnames from 'classnames';
import noop from 'lodash/noop';

const Fab = styled(Box)`
  position: absolute;
  bottom: 10px;
  width: 100%;
  & .left {
    left: 10px;
    right: unset;
  }
  & .right {
    right: 0;
    left: unset;
  }
`;

const StickyButtonPreview = ({ options = {}, color }) => {
  const {
    enabled,
    title,
    buttonText,
    socialProof,
    position = 'right',
  } = options;
  return (
    <>
      {enabled && (
        <Fab color={color} className={position}>
          <LauncherStickyButtonWrapper
            sx={{
              position: 'absolute',
            }}
            className={classnames({
              closed: false,
              left: position === 'left',
            })}
          >
            <StickyButton
              completion={10}
              data={options}
              onClose={noop}
              onOkClick={noop}
            />
          </LauncherStickyButtonWrapper>
        </Fab>
      )}
    </>
  );
};

export default StickyButtonPreview;
